import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useId } from "react";
import styles from "./index.module.css";
export const PopupInput = ({ name, value, setInput, onEnter, autoFocus = false }) => {
    const id = useId();
    const handleKeyDown = (e) => {
        if (e.key === 'Enter' && onEnter) {
            e.preventDefault();
            onEnter();
        }
    };
    return (_jsxs("div", Object.assign({ className: styles.inputWrapper }, { children: [_jsx("input", { className: styles.input, id: id, value: value, onChange: (e) => setInput(e.target.value), onKeyDown: handleKeyDown, autoFocus: autoFocus }), _jsx("label", Object.assign({ className: styles.inputLabel, htmlFor: id }, { children: name }))] })));
};
